import React from 'react';
import { useSelector } from 'react-redux';
import ReactPlayer from 'react-player';
import { Spin, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import NoData from '../../../assets/icons/nodata.png';

const CameraViewInfo = ({ selectedStream, topRef, seekTime }) => {
  const {
    generateLinkStorageFileByTime,
    loadingGenerateLinkStorageFileByTime,
  } = useSelector((state) => state);
  const isLoading = loadingGenerateLinkStorageFileByTime?.includes(
    selectedStream?.serial
  );

  return (
    <div
      style={{
        aspectRatio: '16/9',
      }}
    >
      {seekTime === 0 ? (
        <div>
          <img
            alt="thumbnail"
            src={selectedStream?.thumbnail}
            width={'100%'}
            style={{
              height: '100%',
              maxHeight: 365,
            }}
          />
        </div>
      ) : generateLinkStorageFileByTime?.[selectedStream?.serial] ? (
        <ReactPlayer
          ref={topRef}
          url={
            generateLinkStorageFileByTime?.[selectedStream?.serial]?.secureLink
          }
          onReady={() => {}}
          width="100%"
          height="100%"
          controls={false}
          playing={true}
        />
      ) : (
        <div className="record-nodata">
          <div style={{ position: 'relative' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: isLoading ? 'transparent' : 'white',
                padding: '0 8px 8px',
              }}
            >
              <Tooltip title={selectedStream?.name} placement="topLeft">
                <div
                  className="name-camera"
                  style={{
                    fontSize: 13,
                    textOverflow: 'ellipsis',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 1,
                    display: '-webkit-box',
                    overflow: 'hidden',
                  }}
                >
                  {selectedStream?.name}
                </div>
              </Tooltip>
            </div>
            {isLoading ? (
              <div className="loading">
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
                />
              </div>
            ) : (
              <img alt="NoData" src={NoData} style={{ width: '100%' }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CameraViewInfo;
